var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEwi50Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 38,
    viewBox: "0 0 53 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1118 30.8831C10.5398 30.8831 9.39977 29.9111 9.39977 28.2911C9.39977 26.1671 11.0198 24.8831 12.6158 24.8831C13.8398 24.8831 14.3318 25.5191 14.3318 26.1311C14.3318 27.2231 13.0718 27.9431 10.9598 28.3391C11.0318 29.2391 11.6558 29.9351 12.6758 29.9351C13.9598 29.9351 14.6918 29.2991 15.0158 28.7951C15.1718 28.7951 15.2558 28.8911 15.2078 29.1071C15.0998 29.6351 13.9478 30.8831 12.1118 30.8831ZM12.6278 25.4831C11.9438 25.4831 11.1038 26.2751 10.9718 27.7751C12.4358 27.4271 13.0478 26.6951 13.0478 25.9031C13.0478 25.6511 12.8798 25.4831 12.6278 25.4831ZM23.9818 28.4711C23.6218 28.4711 23.3098 28.3511 23.0698 28.1831C22.9138 28.6511 22.7338 29.0711 22.5418 29.3711C21.9898 30.2591 21.3898 30.8831 20.4298 30.8831C19.5778 30.8831 19.0018 30.3671 18.7738 29.5511C18.3058 30.3071 17.6578 30.8831 16.8178 30.8831C15.6178 30.8831 15.0538 30.0431 15.0538 28.6631C15.0538 28.0751 15.1258 27.3911 15.2458 26.6231L15.3418 26.0231C15.4618 25.2671 15.3538 24.9911 15.3538 24.9911C15.3538 24.9911 15.5338 24.8831 15.9778 24.8831C16.9018 24.8831 17.0098 25.2311 16.8658 26.0711L16.6978 27.0431C16.5898 27.6551 16.5538 28.1591 16.5538 28.5431C16.5538 29.5271 16.8658 29.8391 17.3818 29.8391C17.9698 29.8391 18.4258 29.1911 18.6778 28.1951C18.7018 27.7031 18.7618 27.1391 18.8458 26.6231L18.9418 26.0231C19.0738 25.2671 18.9538 24.9911 18.9538 24.9911C18.9538 24.9911 19.1338 24.8831 19.5778 24.8831C20.5018 24.8831 20.6098 25.2311 20.4658 26.0711L20.2978 27.0431C20.1778 27.7151 20.1418 28.1831 20.1418 28.5911C20.1418 29.4791 20.4418 29.8391 20.9818 29.8391C21.6898 29.8391 22.2778 28.9391 22.4578 27.5471C22.1218 27.0551 21.9298 26.4671 21.9298 25.7711C21.9298 25.2551 22.2538 24.8831 22.7458 24.8831C23.1658 24.8831 23.5018 25.1471 23.5018 25.7831C23.5018 26.3231 23.4058 26.9591 23.2498 27.5471C23.4178 27.7751 23.6818 27.9431 24.0658 27.9431C24.9778 27.9431 25.3498 26.9951 25.3498 26.9951C25.5418 26.9951 25.5898 27.1631 25.5658 27.2951C25.4938 27.7151 24.9658 28.4711 23.9818 28.4711ZM24.6043 28.2431L24.9883 26.0231C25.1203 25.2551 25.0003 24.9911 25.0003 24.9911C25.0003 24.9911 25.1803 24.8831 25.6243 24.8831C26.5483 24.8831 26.6563 25.2311 26.5123 26.0711L26.0443 28.7831C25.9243 29.5031 26.1283 29.8391 26.5603 29.8391C26.9683 29.8391 27.5083 29.4431 27.8203 28.7951C27.9763 28.7951 28.0843 28.8911 28.0483 29.1071C27.9283 29.7431 27.0643 30.8831 25.9003 30.8831C25.0723 30.8831 24.4963 30.3431 24.4963 29.3831C24.4963 29.1431 24.5203 28.7231 24.6043 28.2431ZM25.4083 23.0831C25.4083 22.5911 25.7923 22.2191 26.2483 22.2191C26.7043 22.2191 26.9923 22.5431 26.9923 22.9751C26.9923 23.3951 26.6563 23.8031 26.1283 23.8031C25.6963 23.8031 25.4083 23.5031 25.4083 23.0831Z",
    fill: "#2B2133"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_943_2089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2685 28.3698L32.4579 25.7216L34.5439 26.6814L34.2877 29.294C34.2877 29.294 34.7932 29.6874 34.7268 30.076C34.5652 31.0219 32.0187 30.3782 32.0187 30.3782C32.0187 30.3782 29.7591 29.6195 30.2255 28.8497C30.4688 28.4482 31.2685 28.3698 31.2685 28.3698Z",
    fill: "#5F4077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9615 28.3875L43.7721 25.7393L41.6861 26.699L41.9423 29.3117C41.9423 29.3117 41.4367 29.7051 41.5031 30.0937C41.6648 31.0395 44.2113 30.3959 44.2113 30.3959C44.2113 30.3959 46.4709 29.6372 46.0045 28.8674C45.7612 28.4659 44.9615 28.3875 44.9615 28.3875Z",
    fill: "#5F4077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8812 8.59381L41.1662 7.26959C41.2782 7.15415 41.2792 6.97091 41.1685 6.85421L39.8662 5.48122L38.2867 4.13686C38.1742 4.04108 38.0087 4.04151 37.8966 4.13786L36.3346 5.48122L34.9885 6.85029C34.8728 6.96797 34.8738 7.15702 34.9909 7.27338L36.3346 8.6093L37.9078 9.83494C38.0158 9.91905 38.167 9.91943 38.2754 9.83586L39.8491 8.62248C39.8604 8.6137 39.8712 8.60413 39.8812 8.59381Z",
    fill: "url(#paint0_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.101 18.7729L43.6974 15.2509C43.65 15.2019 43.5755 15.191 43.516 15.2244L38.5393 18.0222C38.4074 18.0963 38.3856 18.2753 38.4995 18.375C39.1156 18.9141 40.8827 20.3466 42.4093 20.4818C44.0847 20.6303 46.3835 19.4282 47.0622 19.0483C47.1632 18.9917 47.1815 18.8561 47.101 18.7729Z",
    fill: "url(#paint1_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9893 18.7906L32.3929 15.2686C32.4403 15.2196 32.5148 15.2087 32.5743 15.2421L37.5511 18.0399C37.683 18.114 37.7047 18.2931 37.5908 18.3927C36.9747 18.9319 35.2076 20.3643 33.681 20.4996C32.0057 20.648 29.7068 19.446 29.0281 19.066C28.9272 19.0095 28.9088 18.8738 28.9893 18.7906Z",
    fill: "url(#paint2_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6419 16.8232L46.864 11.4417C46.846 11.3173 46.6921 11.2689 46.6061 11.3606L43.8318 14.3201C43.738 14.4202 43.7549 14.5803 43.8675 14.6587L47.2907 17.0401C47.4522 17.1525 47.67 17.018 47.6419 16.8232Z",
    fill: "url(#paint3_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5036 16.8232L29.2815 11.4417C29.2995 11.3173 29.4534 11.2689 29.5394 11.3606L32.3137 14.3201C32.4075 14.4202 32.3907 14.5803 32.278 14.6587L28.8548 17.0401C28.6933 17.1525 28.4755 17.018 28.5036 16.8232Z",
    fill: "url(#paint4_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2337 9.85343C46.2337 8.73819 44.5296 6.25328 44.087 5.6268C44.033 5.55028 43.9242 5.54291 43.8593 5.61039C43.4077 6.0792 41.8206 7.70704 40.7626 8.53821C39.7928 9.30007 39.7563 9.26691 39.6465 9.78233C39.3497 11.1757 42.3546 12.9572 43.489 12.8216C45.1196 12.6267 46.2337 10.8487 46.2337 9.85343Z",
    fill: "url(#paint5_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0397 9.85343C30.0397 8.73819 31.7439 6.25328 32.1864 5.6268C32.2404 5.55028 32.3492 5.54291 32.4142 5.61039C32.8657 6.0792 34.4528 7.70704 35.5108 8.53821C36.4806 9.30007 36.5172 9.26691 36.627 9.78233C36.9237 11.1757 33.9189 12.9572 32.7844 12.8216C31.1539 12.6267 30.0397 10.8487 30.0397 9.85343Z",
    fill: "url(#paint6_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5862 2.88632C41.4764 2.79743 41.1105 2.19317 40.7811 2.05098C40.4518 1.90878 40.2322 2.54859 39.9394 2.93962C39.6466 3.33065 39.5186 3.46329 39.5186 3.8816C39.5186 4.20154 39.6143 4.3663 39.7564 4.64585C39.8986 4.9254 40.1656 5.22663 40.4701 5.48121C40.8479 5.79713 41.1837 6.00888 41.6777 5.94331C41.9522 5.90687 42.0298 5.87121 42.245 5.64117C42.589 5.2734 42.615 4.96171 42.556 4.46813C42.4787 3.82132 41.5862 2.88632 41.5862 2.88632Z",
    fill: "url(#paint7_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5842 2.88881C34.694 2.79992 35.0599 2.19566 35.3893 2.05347C35.7187 1.91127 35.9382 2.55108 36.231 2.94211C36.5238 3.33314 36.6519 3.46578 36.6519 3.88409C36.6519 4.20403 36.5562 4.36879 36.414 4.64834C36.2718 4.92789 36.0049 5.22912 35.7004 5.4837C35.3225 5.79962 34.9867 6.01137 34.4927 5.9458C34.2182 5.90936 34.1406 5.87369 33.9254 5.64366C33.5814 5.27589 33.5554 4.9642 33.6144 4.47062C33.6917 3.82381 34.5842 2.88881 34.5842 2.88881Z",
    fill: "url(#paint8_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5612 1.74626L38.164 0.199455C38.1051 0.134217 38.003 0.133409 37.943 0.197707L36.5026 1.74252C36.3896 1.86377 36.3963 2.05374 36.5176 2.1667L37.9506 3.5006C38.0089 3.55483 38.0994 3.55412 38.1568 3.49897L39.5464 2.16367C39.6633 2.05137 39.6698 1.86654 39.5612 1.74626Z",
    fill: "url(#paint9_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9879 13.7661L38.1295 10.9805C38.0831 10.954 38.0261 10.9541 37.9798 10.9808L33.1891 13.7498C33.0405 13.8357 33.0389 14.0496 33.1861 14.1377L37.9783 17.0059C38.0253 17.0341 38.084 17.0343 38.1312 17.0066L42.9899 14.1554C43.1389 14.0679 43.1378 13.8521 42.9879 13.7661Z",
    fill: "url(#paint10_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1364 19.8242C38.1364 19.8242 36.1663 20.6355 33.7421 21.092C32.103 21.4007 30.4106 20.6257 29.721 20.0676C29.5288 19.912 29.4465 20.0203 29.4331 20.2672C29.3721 21.3874 29.5997 23.6155 31.787 25.3517C34.8102 27.7514 37.8171 27.8037 38.1364 27.8037V19.8242Z",
    fill: "url(#paint11_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1367 19.8139C38.1367 19.8139 40.1067 20.6252 42.5309 21.0817C44.1701 21.3903 45.8625 20.6154 46.552 20.0573C46.7442 19.9017 46.8265 20.01 46.84 20.2568C46.901 21.3771 46.6733 23.6052 44.4861 25.3413C41.4629 27.7411 38.456 27.7933 38.1367 27.7933V19.8139Z",
    fill: "url(#paint12_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2685 28.3698L32.4579 25.7216L34.5439 26.6814L34.2877 29.294C34.2877 29.294 34.7932 29.6874 34.7268 30.076C34.5652 31.0219 32.0187 30.3782 32.0187 30.3782C32.0187 30.3782 29.7591 29.6195 30.2255 28.8497C30.4688 28.4482 31.2685 28.3698 31.2685 28.3698Z",
    fill: "#5F4077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9615 28.3875L43.7721 25.7393L41.6861 26.699L41.9423 29.3117C41.9423 29.3117 41.4367 29.7051 41.5031 30.0937C41.6648 31.0395 44.2113 30.3959 44.2113 30.3959C44.2113 30.3959 46.4709 29.6372 46.0045 28.8674C45.7612 28.4659 44.9615 28.3875 44.9615 28.3875Z",
    fill: "#5F4077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8812 8.59381L41.1662 7.26959C41.2782 7.15415 41.2792 6.97091 41.1685 6.85421L39.8662 5.48122L38.2867 4.13686C38.1742 4.04108 38.0087 4.04151 37.8966 4.13786L36.3346 5.48122L34.9885 6.85029C34.8728 6.96797 34.8738 7.15702 34.9909 7.27338L36.3346 8.6093L37.9078 9.83494C38.0158 9.91905 38.167 9.91943 38.2754 9.83586L39.8491 8.62248C39.8604 8.6137 39.8712 8.60413 39.8812 8.59381Z",
    fill: "url(#paint13_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.101 18.7729L43.6974 15.2509C43.65 15.2019 43.5755 15.191 43.516 15.2244L38.5393 18.0222C38.4074 18.0963 38.3856 18.2753 38.4995 18.375C39.1156 18.9141 40.8827 20.3466 42.4093 20.4818C44.0847 20.6303 46.3835 19.4282 47.0622 19.0483C47.1632 18.9917 47.1815 18.8561 47.101 18.7729Z",
    fill: "url(#paint14_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9893 18.7906L32.3929 15.2686C32.4403 15.2196 32.5148 15.2087 32.5743 15.2421L37.5511 18.0399C37.683 18.114 37.7047 18.2931 37.5908 18.3927C36.9747 18.9319 35.2076 20.3643 33.681 20.4996C32.0057 20.648 29.7068 19.446 29.0281 19.066C28.9272 19.0095 28.9088 18.8738 28.9893 18.7906Z",
    fill: "url(#paint15_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6419 16.8232L46.864 11.4417C46.846 11.3173 46.6921 11.2689 46.6061 11.3606L43.8318 14.3201C43.738 14.4202 43.7549 14.5803 43.8675 14.6587L47.2907 17.0401C47.4522 17.1525 47.67 17.018 47.6419 16.8232Z",
    fill: "url(#paint16_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5036 16.8232L29.2815 11.4417C29.2995 11.3173 29.4534 11.2689 29.5394 11.3606L32.3137 14.3201C32.4075 14.4202 32.3907 14.5803 32.278 14.6587L28.8548 17.0401C28.6933 17.1525 28.4755 17.018 28.5036 16.8232Z",
    fill: "url(#paint17_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2337 9.85343C46.2337 8.73819 44.5296 6.25328 44.087 5.6268C44.033 5.55028 43.9242 5.54291 43.8593 5.61039C43.4077 6.0792 41.8206 7.70704 40.7626 8.53821C39.7928 9.30007 39.7563 9.26691 39.6465 9.78233C39.3497 11.1757 42.3546 12.9572 43.489 12.8216C45.1196 12.6267 46.2337 10.8487 46.2337 9.85343Z",
    fill: "url(#paint18_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0397 9.85343C30.0397 8.73819 31.7439 6.25328 32.1864 5.6268C32.2404 5.55028 32.3492 5.54291 32.4142 5.61039C32.8657 6.0792 34.4528 7.70704 35.5108 8.53821C36.4806 9.30007 36.5172 9.26691 36.627 9.78233C36.9237 11.1757 33.9189 12.9572 32.7844 12.8216C31.1539 12.6267 30.0397 10.8487 30.0397 9.85343Z",
    fill: "url(#paint19_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5862 2.88632C41.4764 2.79743 41.1105 2.19317 40.7811 2.05098C40.4518 1.90878 40.2322 2.54859 39.9394 2.93962C39.6466 3.33065 39.5186 3.46329 39.5186 3.8816C39.5186 4.20154 39.6143 4.3663 39.7564 4.64585C39.8986 4.9254 40.1656 5.22663 40.4701 5.48121C40.8479 5.79713 41.1837 6.00888 41.6777 5.94331C41.9522 5.90687 42.0298 5.87121 42.245 5.64117C42.589 5.2734 42.615 4.96171 42.556 4.46813C42.4787 3.82132 41.5862 2.88632 41.5862 2.88632Z",
    fill: "url(#paint20_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5842 2.88881C34.694 2.79992 35.0599 2.19566 35.3893 2.05347C35.7187 1.91127 35.9382 2.55108 36.231 2.94211C36.5238 3.33314 36.6519 3.46578 36.6519 3.88409C36.6519 4.20403 36.5562 4.36879 36.414 4.64834C36.2718 4.92789 36.0049 5.22912 35.7004 5.4837C35.3225 5.79962 34.9867 6.01137 34.4927 5.9458C34.2182 5.90936 34.1406 5.87369 33.9254 5.64366C33.5814 5.27589 33.5554 4.9642 33.6144 4.47062C33.6917 3.82381 34.5842 2.88881 34.5842 2.88881Z",
    fill: "url(#paint21_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5612 1.74626L38.164 0.199455C38.1051 0.134217 38.003 0.133409 37.943 0.197707L36.5026 1.74252C36.3896 1.86377 36.3963 2.05374 36.5176 2.1667L37.9506 3.5006C38.0089 3.55483 38.0994 3.55412 38.1568 3.49897L39.5464 2.16367C39.6633 2.05137 39.6698 1.86654 39.5612 1.74626Z",
    fill: "url(#paint22_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9879 13.7661L38.1295 10.9805C38.0831 10.954 38.0261 10.9541 37.9798 10.9808L33.1891 13.7498C33.0405 13.8357 33.0389 14.0496 33.1861 14.1377L37.9783 17.0059C38.0253 17.0341 38.084 17.0343 38.1312 17.0066L42.9899 14.1554C43.1389 14.0679 43.1378 13.8521 42.9879 13.7661Z",
    fill: "url(#paint23_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1364 19.8242C38.1364 19.8242 36.1663 20.6355 33.7421 21.092C32.103 21.4007 30.4106 20.6257 29.721 20.0676C29.5288 19.912 29.4465 20.0203 29.4331 20.2672C29.3721 21.3874 29.5997 23.6155 31.787 25.3517C34.8102 27.7514 37.8171 27.8037 38.1364 27.8037V19.8242Z",
    fill: "url(#paint24_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1367 19.8139C38.1367 19.8139 40.1067 20.6252 42.5309 21.0817C44.1701 21.3903 45.8625 20.6154 46.552 20.0573C46.7442 19.9017 46.8265 20.01 46.84 20.2568C46.901 21.3771 46.6733 23.6052 44.4861 25.3413C41.4629 27.7411 38.456 27.7933 38.1367 27.7933V19.8139Z",
    fill: "url(#paint25_linear_943_2089)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.785689,
    cy: 0.785689,
    r: 0.785689,
    transform: "matrix(-1 0 0 1 43.9834 22.9564)",
    fill: "#E3C4FB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.785689,
    cy: 0.785689,
    r: 0.785689,
    transform: "matrix(-1 0 0 1 33.7295 22.9564)",
    fill: "#E3C4FB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.9424,
    cy: 22.5556,
    r: 1.2525,
    fill: "#5F4077"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.1973,
    cy: 19.2556,
    r: 1.2525,
    fill: "#5F4077"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5042 19.1881C10.5342 19.0021 10.6602 18.9481 10.8402 18.9481C11.1402 18.9481 11.6562 19.0861 12.4602 19.0861C12.8082 19.0861 13.0242 18.9901 13.0242 18.9901C13.0542 19.0201 13.0962 19.0921 13.0962 19.2361C13.0962 19.5781 12.8862 19.7761 12.3822 19.7761C11.8182 19.7761 11.2782 19.5421 10.8162 19.4521L10.5762 20.8681C10.7982 20.7661 11.0442 20.7061 11.3682 20.7061C12.1962 20.7061 12.6522 21.2161 12.6522 21.8701C12.6522 22.8301 11.9802 23.4481 11.0382 23.4481C10.3122 23.4481 9.9222 23.0221 9.8322 22.5601C9.7962 22.3801 9.8922 22.2301 10.0362 22.2661C10.0842 22.6681 10.3722 22.9261 10.8222 22.9261C11.4282 22.9261 11.8182 22.4641 11.8182 21.8221C11.8182 21.3601 11.5542 21.0721 11.1402 21.0721C10.6482 21.0721 10.4082 21.4141 10.4082 21.4141C10.2402 21.4141 10.1382 21.3241 10.1682 21.1561L10.5042 19.1881ZM15.3066 18.9481C16.2126 18.9481 16.6266 19.5841 16.6266 20.5321C16.6266 22.1221 15.8946 23.4481 14.7006 23.4481C13.9026 23.4481 13.3986 22.8901 13.3986 21.8641C13.3986 20.2141 14.1786 18.9481 15.3066 18.9481ZM15.3006 19.2781C15.0546 19.2781 14.8086 19.5241 14.6346 19.9621C14.4246 20.4961 14.2326 21.3901 14.2326 22.2601C14.2326 22.8601 14.4066 23.1181 14.7246 23.1181C14.9646 23.1181 15.2046 22.8901 15.3906 22.4341C15.6066 21.9061 15.7926 21.0181 15.7926 20.1361C15.7926 19.5001 15.5946 19.2781 15.3006 19.2781Z",
    fill: "#2B2133"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1992 21.8981H17.3754L17.4129 21.6956C17.4579 21.4594 17.4167 21.3731 17.4167 21.3731C17.4167 21.3731 17.4729 21.3394 17.6117 21.3394C17.9004 21.3394 17.9379 21.4481 17.8892 21.7106L17.8554 21.8981H18.2267C18.2267 21.8981 18.2529 21.9281 18.2529 21.9769C18.2529 22.0406 18.2079 22.0856 18.1254 22.0856H17.8217L17.6417 23.1169C17.6042 23.3231 17.6792 23.4469 17.8554 23.4469C18.0692 23.4469 18.2229 23.2781 18.3054 23.1206C18.3542 23.1206 18.3879 23.1544 18.3729 23.2181C18.3167 23.4469 18.0129 23.7731 17.6567 23.7731C17.3792 23.7731 17.1617 23.5781 17.1617 23.2781C17.1617 23.1919 17.1692 23.0681 17.2029 22.8769L17.3417 22.0856H17.0979C17.0979 22.0856 17.0717 22.0556 17.0717 22.0069C17.0717 21.9431 17.1167 21.8981 17.1992 21.8981ZM20.0411 23.4469C20.1874 23.4469 20.3261 23.3381 20.4349 23.1206C20.4836 23.1206 20.5174 23.1506 20.5061 23.2181C20.4686 23.4169 20.1949 23.7731 19.8461 23.7731C19.5649 23.7731 19.3924 23.5856 19.3924 23.3044C19.3924 23.2069 19.4186 23.0606 19.4486 22.8769L19.5199 22.4644C19.5499 22.2844 19.5124 22.2281 19.4299 22.2281C19.1936 22.2281 18.8336 22.7869 18.7211 23.4169C18.6799 23.6531 18.7174 23.7394 18.7174 23.7394C18.7174 23.7394 18.6611 23.7731 18.5224 23.7731C18.2336 23.7731 18.1999 23.6644 18.2449 23.4019L18.6611 21.0169C18.7024 20.7806 18.6649 20.6944 18.6649 20.6944C18.6649 20.6944 18.7211 20.6606 18.8599 20.6606C19.1486 20.6606 19.1824 20.7694 19.1374 21.0319L18.8899 22.4419C19.0361 22.1981 19.3174 21.8981 19.6249 21.8981C19.8611 21.8981 20.0111 22.0519 20.0111 22.2844C20.0111 22.3669 19.9961 22.4756 19.9774 22.5881L19.8874 23.1169C19.8499 23.3269 19.8986 23.4469 20.0411 23.4469Z",
    fill: "#2B2133"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_943_2089",
    x: 24.5399,
    y: 1.19209e-7,
    width: 28.2598,
    height: 31.9598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.6,
    dy: 0.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_943_2089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_943_2089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_943_2089",
    x1: 38.0729,
    y1: 3.97049,
    x2: 38.0729,
    y2: 9.97784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_943_2089",
    x1: 42.7661,
    y1: 15.1676,
    x2: 42.7661,
    y2: 20.4945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_943_2089",
    x1: 33.3242,
    y1: 15.1854,
    x2: 33.3242,
    y2: 20.5122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_943_2089",
    x1: 45.6849,
    y1: 11.1331,
    x2: 45.6849,
    y2: 17.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_943_2089",
    x1: 30.4606,
    y1: 11.1331,
    x2: 30.4606,
    y2: 17.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_943_2089",
    x1: 42.9299,
    y1: 5.48122,
    x2: 42.9299,
    y2: 12.8289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_943_2089",
    x1: 33.3436,
    y1: 5.48122,
    x2: 33.3436,
    y2: 12.8289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_943_2089",
    x1: 41.0496,
    y1: 2.03073,
    x2: 41.0496,
    y2: 5.95524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_943_2089",
    x1: 35.1208,
    y1: 2.03322,
    x2: 35.1208,
    y2: 5.95773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_943_2089",
    x1: 38.027,
    y1: 0.0781631,
    x2: 38.027,
    y2: 3.59726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_943_2089",
    x1: 38.0912,
    y1: 10.9376,
    x2: 38.0912,
    y2: 17.0516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_943_2089",
    x1: 38.1365,
    y1: 19.8139,
    x2: 38.1365,
    y2: 27.8037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_943_2089",
    x1: 38.1365,
    y1: 19.8139,
    x2: 38.1365,
    y2: 27.8037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_943_2089",
    x1: 38.0729,
    y1: 3.97049,
    x2: 38.0729,
    y2: 9.97784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_943_2089",
    x1: 42.7661,
    y1: 15.1676,
    x2: 42.7661,
    y2: 20.4945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_943_2089",
    x1: 33.3242,
    y1: 15.1854,
    x2: 33.3242,
    y2: 20.5122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_943_2089",
    x1: 45.6849,
    y1: 11.1331,
    x2: 45.6849,
    y2: 17.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_943_2089",
    x1: 30.4606,
    y1: 11.1331,
    x2: 30.4606,
    y2: 17.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_943_2089",
    x1: 42.9299,
    y1: 5.48122,
    x2: 42.9299,
    y2: 12.8289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_943_2089",
    x1: 33.3436,
    y1: 5.48122,
    x2: 33.3436,
    y2: 12.8289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_943_2089",
    x1: 41.0496,
    y1: 2.03073,
    x2: 41.0496,
    y2: 5.95524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_943_2089",
    x1: 35.1208,
    y1: 2.03322,
    x2: 35.1208,
    y2: 5.95773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_943_2089",
    x1: 38.027,
    y1: 0.0781631,
    x2: 38.027,
    y2: 3.59726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_943_2089",
    x1: 38.0912,
    y1: 10.9376,
    x2: 38.0912,
    y2: 17.0516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_943_2089",
    x1: 38.1365,
    y1: 19.8139,
    x2: 38.1365,
    y2: 27.8037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_943_2089",
    x1: 38.1365,
    y1: 19.8139,
    x2: 38.1365,
    y2: 27.8037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEwi50Logo);
export default __webpack_public_path__ + "static/media/ewi50_logo.aca10ad2d3ee89cb172912d200a699f1.svg";
export { ForwardRef as ReactComponent };